import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {AndroidIcon, IphoneIcon, GameIcon, FlutterIcon, HealthcareIcon, ReactIcon} from "../../../../app-constants";

const StackItem = [
    {
        icon: AndroidIcon,
        title: 'Android App Development',
        description: "Elevate your business with TekRevol's Android app development. We use Java and Kotlin to create user-friendly apps tailored to your goals, enhancing your Android presence and connecting with your audience effectively.",
    },
    {
        icon: IphoneIcon,
        title: 'iPhone App Development',
        description: "Experience excellence in iOS app development with TekRevol. Our experts leverage Swift and Objective-C to create sleek, high-performance iPhone apps tailored to meet your business goals and captivate your audience.",
    },
    {
        icon: GameIcon,
        title: 'Game App Development',
        description: "Level up your gaming experience with TekRevol. Our game app developers use cutting-edge technologies like Unity and Unreal Engine to create immersive, engaging games that keep users hooked and entertained. ",
    },
    {
        icon: FlutterIcon,
        title: 'Flutter app development',
        description: "TekRevol's Flutter app development ensures cross-platform excellence. Using Dart programming language, we craft visually stunning and responsive apps that seamlessly run on both iOS and Android devices, providing a cost-effective solution.",
    },
    {
        icon: HealthcareIcon,
        title: 'Healthcare app development',
        description: "Transform healthcare solutions with TekRevol. Our developers ensure HIPAA compliance while using cutting-edge technologies like Swift and Kotlin, creating secure, intuitive healthcare apps that prioritize patient care and accessibility.",
    },
    {
        icon: ReactIcon,
        title: 'React Native app development',
        description: "Enhance your brand across platforms with TekRevol’s React Native expertise. Our developers use JavaScript to seamlessly craft high-performance apps, ensuring a native experience on both iOS and Android devices, all while optimizing costs.",
    },

];

function Improvise(props) {
    return (
        <div className="improvise_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                <Col xs={12} md={12} lg={12} xl={10} xxl={4} className="m-xl-auto m-xxl-0">
                        <h2>TekRevol's Game-Changing Mobile App Development Services</h2>
                        <p className="impro_para">Our services are crafted to transform your ideas into impactful digital experiences. The mission is clear: elevate brands to leverage technology for meaningful change. We're your partners in navigating the digital revolution, offering straightforward solutions tailored to achieve your unique business goals.</p>
                        <p className="impro_para">Here are the versatile services that TekRevol offers:</p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
                        <div className="stack_box">
                            {StackItem.map((item, index) => (
                                <div className="stack_item" key={index}>
                                    <div className="stack_title">
                                        {item.icon}
                                        <h5>{item.title}</h5>
                                    </div>
                                    <p>{item.description}</p>
                                </div>
                            ))}
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Improvise;